export default {
    RECIPIENTS_FETCH: 'RECIPIENTS_FETCH',
    RECIPIENTS_FETCH_SUCCESS: 'RECIPIENTS_FETCH_SUCCESS',
    RECIPIENTS_FETCH_FAILED: 'RECIPIENTS_FETCH_FAILED',
    RECIPIENTS_SENDERS_FETCH: 'RECIPIENTS_SENDERS_FETCH',
    RECIPIENTS_SENDERS_FETCH_SUCCESS: 'RECIPIENTS_SENDERS_FETCH_SUCCESS',
    RECIPIENTS_SENDERS_FETCH_FAILED: 'RECIPIENTS_SENDERS_FETCH_FAILED',
};
